export enum MessagingConversationScreenRouteMessages {
  INPUT_PLACEHOLDER_MSG = 'Type your message...',
  DISABLED_PLACEHOLDER_MSG = "You don't have permission to message in this thread",
}
